class MainBlog extends HTMLElement {
    constructor() {
        super();

        this.tagItems = this.querySelectorAll("[js-tag-item]");
        this.mainBlog = this.querySelector("[js-main-blog]");
        this.mainBlog_one = this.querySelector("[js-main-blog-one]");
        // Assuming `currentTags` is available as a global variable or can be extracted from URL
        this.currentTags = window.currentTags || null;  // You can set this variable dynamically

        this.tagItems.forEach(tag => {
            tag.addEventListener("click", this.renderBlog.bind(this));
        });

        this.init();
    }

    init() {
        this.paginationItems = this.querySelectorAll("[js-pagination-item]");
        this.paginationItems.forEach(pagination => pagination.addEventListener("click", this.renderBlog.bind(this)));
        const url = window.location.href;  
        // Call the method to set the active class based on `currentTags` on page load
        this.updateActiveTag(url);
    }

    renderBlog(evt) {
        evt.preventDefault();

        const { currentTarget } = evt;
        const isTag = currentTarget.classList.contains("blog__tag");

        const href = currentTarget.getAttribute("href");
        const url = isTag ? `${href}?section_id=${this.mainBlog.getAttribute('data-section-id')}` : `${href}&section_id=${this.mainBlog.getAttribute('data-section-id')}`;
        const url1 = isTag ? `${href}?section_id=${this.mainBlog_one.getAttribute('data-section-id')}` : `${href}&section_id=${this.mainBlog_one.getAttribute('data-section-id')}`;

        this.updateLoading(true);
        isTag ? this.updateStatus(currentTarget) : "";
        this.updateScroll();
        this.updateURLHash(href);
        this.renderSectionFromFetch(url);
        this.renderSectionFromFetch(url1);

        // After rendering, ensure the active tag is set correctly
        this.updateActiveTag(url);
    }

    updateLoading(isLoading) {
        isLoading ? this.mainBlog.classList.add("loading") : this.mainBlog.classList.remove("loading");
        isLoading ? this.mainBlog_one.classList.add("loading") : this.mainBlog_one.classList.remove("loading");
    }

    updateStatus(target) {
        this.tagItems.forEach(tag => tag.classList.remove('active'));
        target.classList.add("active");
    }

    updateScroll() {
        const scrollTo = this.offsetTop;
        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
    }

    updateURLHash(url) {
        history.pushState({ url }, '', url);
    }

    renderSectionFromFetch(url) {
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                this.mainBlog.innerHTML = doc.querySelector("[js-main-blog]").innerHTML;
                this.mainBlog_one.innerHTML = doc.querySelector("[js-main-blog-one]").innerHTML;
                this.init();
            })
            .finally(() => {
                this.updateLoading(false);
            });
    }

    // Method to set the active class based on currentTags
    updateActiveTag(url) {
    console.log('it works....',url);
var currentUrl  = url;
        var match = currentUrl.match(/\/tagged\/([^\/]+)/);
        match = match ? match[1] : null;
      console.log(match,'match');
        // if (!this.currentTags) return; 
      // If no tag is active, return early

        // Loop through each tag item and check if it matches currentTags
        this.tagItems.forEach(tag => {
          console.log('it works');
            const tagHandle = tag.getAttribute('data-tag');  // assuming each tag has data-tag attribute
            const notagHandle = tag.getAttribute('href');  
            console.log(tagHandle,'tagHandle');
            if(tagHandle == '' && notagHandle == '/blogs/all-blogs' && match == null){
              tag.classList.add('active');
            }
            else if (match === tagHandle) {
                tag.classList.add('active');  // Add 'active' class if it matches
            } else {
                tag.classList.remove('active');  // Remove 'active' class if it doesn't match
            }
        });
    }
}

customElements.define('main-blog', MainBlog);
